export function loadComponentChannelManager() {
    return import("./componentDomChannel").then((module) => module.initializeChannel(document));
}
